module.exports = __webpack_public_path__ + "media/images/squadBet__playerPlaceholder-318e2953f036dde478dbdb5eb6817e71.png";